import {actions as A} from '../constants/actions';

const defaultState = {
  shumaTypeID: null,
  propertyTypeID: null,
  firmShumaID: null,
  loading: false,
  error: false,
  errorMessage: null
};

export default (state = defaultState, {type, payload}) => {
  switch (type) {
    case A.GET_SHUMA_PROPERTIES:
      return {...state};

    case A.GET_SHUMA_PROPERTIES_SUCCESS:
      const {shumaTypeID, propertyTypeID, firmShumaID} = payload;
      return {
        ...state,
        loading: false,
        error: false,
        shumaTypeID,
        propertyTypeID,
        firmShumaID,
      };

    case A.GET_SHUMA_PROPERTIES_FAILURE:
      return {...state, loading: false, error: true, errorMessage: payload};

    case A.CLEAR_INSPECTION:
      return {...defaultState};

    default:
      return state;
  }
}

